export class PagingInfo {
  start: number;
  end: number;
  pageIndex: number;

  setStart(value: number): void {
    this.start = value;
  }

  getStart(): number {
    return this.start;
  }

  setEnd(value: number): void {
    this.end = value;
  }

  getEnd(): number {
    return this.end;
  }

  setPageIndex(value: number): void {
    this.pageIndex = value;
  }

  getPageIndex(): number {
    return this.pageIndex;
  }
}
